import React, { useEffect } from 'react'
import {
  CentraisOperacaoDropdown,
  CustomPanel,
  PageHeader,
  Periodo,
  ThreeDots,
} from '../../../../components'
import { useMultiploCicloEntregaHook } from './MultiploCicloEntregaHook'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import ModalMultiploCicloEntrega from './ModalMultiploCicloEntrega'

function MultiploCicloEntrega({ history, dispatch }) {
  const { state, localDispatch } = useMultiploCicloEntregaHook()

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.loadingMessage) {
      dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
    } else {
      dispatch(hideLoadingBox())
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.navigateToImportacao) {
      localDispatch.resetState()
      history.push('/main/entregas/importacao-multiplo-ciclo-entrega', {
        mCiclo: state.selectedMultiCiclo,
      })
    }
  }, [state.navigateToImportacao])

  useEffect(() => {
    const { selectedCentral, pInicial, pFinal } = state
    localDispatch.fetchMutiploCiclos(selectedCentral, pInicial, pFinal)
  }, [])

  // Render
  return (
    <>
      <PageHeader>3.13 - Importação Multiplos Ciclos de Entrega</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => localDispatch.openDialog(true)} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-4" style={{ paddingTop: 35 }}>
              <CentraisOperacaoDropdown
                value={state.selectedCentral}
                onChange={value => {
                  localDispatch.fetchMutiploCiclos(value, state.pInicial, state.pFinal)
                }}
              />
            </div>
            <div className="p-col-4">
              <Periodo
                periodoInicial={state.pInicial}
                periodoFinal={state.pFinal}
                onPesquisar={(pInicial, pFinal) => {
                  localDispatch.fetchMutiploCiclos(state.selectedCentral, pInicial, pFinal)
                }}
              />
            </div>
          </div>
          <div className="p-col-12">
            <DataTable value={state.multiplosCiclos} emptyMessage={'Nenhum ciclo encontrado . . .'}>
              <Column field={'created_at'} header={'Criado Em'} style={tableCellCentered()} />
              <Column field={'name'} header={'Multiplo Ciclo'} />
              <Column
                header={'Menu'}
                style={tableCellCentered(70)}
                body={mCiclo => (
                  <ThreeDots
                    items={['Editar', 'Apagar', 'Importação']}
                    onClick={item => localDispatch.onMenuItemClicked(item, mCiclo)}
                  />
                )}
                bodyStyle={tableCellCentered()}
              />
            </DataTable>
          </div>
        </CustomPanel>
      </div>
      <ModalMultiploCicloEntrega
        operationCenterId={state.selectedCentral}
        onResponse={localDispatch.onModalResponse}
        selectedMutiCiclo={state.selectedMultiCiclo}
        visible={state.showDialog}
      />
    </>
  )
}

export default connect()(withRouter(MultiploCicloEntrega))
